import React, { PureComponent } from "react";
import { View, StyleSheet, ActivityIndicator, Keyboard } from "react-native";
import OrdersListView from "./View";
import colors from "@constants/color";
import SearchBar from "@components/SearchBar";
import CloseIcon from "@assets/svg/CloseIcon";
// import RefreshAndFocusHandler from "../../components/HOC/RefreshAndFocusHandler";
import metrics from "@constants/metrics";
import SearchHome from "@assets/svg/SearchHome";

import t from "@constants/localization";

const PATH = "screens/SupportTree/components/OrderList/index";

const filterKeys = ["order_id", "user_name", "user_phone"];

class OrdersList extends PureComponent {
  state = { searchQuery: "" };

  filterOrders = (order) => {
    const { searchQuery } = this.state;
    if (!searchQuery) return true;

    return filterKeys.some(
      (key) =>
        order[key]?.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1,
    );
  };

  get orders() {
    const { children } = this.props;
    return children.filter(this.filterOrders);
  }

  clearSearchQuery = () => {
    this.setState({
      ...this.state,
      searchQuery: "",
    });
  };

  onPressOrder = (order) => {
    this.props.onSubmit(order.order_id);
  };

  get shouldShowSearchBar() {
    return this.orders && Array.isArray(this.orders) && this.orders.length > 0;
  }

  render() {
    const paddingTop = this.props.contentContainerStyle
      ? this.props.contentContainerStyle.paddingTop
      : 0;

    const viewProps = {
      onPressOrder: this.onPressOrder,
      orders: this.orders,
      selectButtonText: this.props.nextButtonText,
      clearSearchQuery: this.clearSearchQuery,
      contentContainerStyle: {
        paddingTop,
      },
    };

    return (
      <View style={styles.orderContainer}>
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: 15,
            // height: metrics.screenHeight / 10,
            paddingVertical: 10,
            width: metrics.screenWidth,
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: colors.darkBackground,
          }}
        >
          <SearchBar
            query={this.state.searchQuery}
            placeholder={t(`${PATH}/searchOrder`)}
            handleQueryChange={(searchQuery) => this.setState({ searchQuery })}
            onPressRightIcon={() => this.setState({ searchQuery: "" })}
            shouldShowIcon={true}
            rightIcon={!this.state.searchQuery ? <SearchHome /> : <CloseIcon />}
          />
        </View>
        <View style={{ padding: 10, flex: 1 }}>
          <OrdersListView {...viewProps} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  orderContainer: {
    flex: 1,
    backgroundColor: "#fff",
  },
});

export default OrdersList;
